import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, SelectField, MenuItem, IconButton, FontIcon } from "material-ui"
import FinddDatePicker from "../../common/FinddDatePicker"
import AppStateStore from "../../../stores/AppStateStore"
import AccountStore from "../../../stores/AccountStore"
import strings from "../../../localization/strings"
import moment from "moment"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import { IPayrollPayCalendar, EEstimatedTimeReportType, IDate, EExceptionType, IUserFilter } from "../../../models"
import * as reportAction from "../../../actions/ReportAction"
import TimecardDateRange from "../../../components/timecard/TimecardDateRange"
import { grey800, blueGrey500 } from "material-ui/styles/colors"
import * as payrollHelper from "../../../helpers/payrollHelper"

interface IProps {
    referenceDate: IDate
    selectedPayrollPayCalendar: IPayrollPayCalendar
    userFilter: IUserFilter
    handleClose(): void

    filterByDefaultHierarchy: boolean
    filterDirectReportsOnly: boolean
    filterByPunchHierarchy: boolean
    filterByException: boolean
    filterExceptions: EExceptionType[]
}
interface IState {
    reportType: EEstimatedTimeReportType
    referenceDate: IDate
}
export default class EstimatedTimeReportDialog extends React.Component<IProps, IState> {
    private FinddDatePicker
    constructor(props) {
        super(props)
        this.state = {
            reportType: EEstimatedTimeReportType.Weekly,
            referenceDate: props.referenceDate
        }
        autobind(this)
    }

    handleDownload() {
        this.props.handleClose()
        reportAction.downloadEstimatedTimeReport(AccountStore.getCurrentAccount().Id, HierarchySettingsStore.getGlobalLevelItemFilterId(), payrollHelper.getPayGroupIdsByPayrollPayCalendar(this.props.selectedPayrollPayCalendar), this.props.userFilter, moment(this.state.referenceDate).utc(true).format(), this.props.filterDirectReportsOnly, this.props.filterByDefaultHierarchy, this.props.filterByPunchHierarchy, this.props.filterByException, this.props.filterExceptions, this.state.reportType)
    }

    render() {
        return (
            <Dialog
                open
                title={strings.Estimated_Time_Report}
                actions={[
                    <FlatButton
                        data-intercom-target={"Timecards-Reports-Btn-CloseEstimatedTimeReportDialog"}
                        key="cancel"
                        label={strings.CANCEL}
                        secondary
                        onTouchTap={this.props.handleClose}
                    />,
                    <FlatButton
                        data-intercom-target={"Timecards-Reports-Btn-DownloadEstimatedTimeReport"}
                        key="download"
                        label={strings.Download}
                        primary
                        onTouchTap={() => AppStateStore.setConfirmDialogContent({
                            content: strings.Are_you_sure_you_want_to_download_the_Estimated_Time_Report_for_selected_option,
                            confirm: this.handleDownload
                        })}
                    />
                ]}
            >
                <SelectField
                    data-intercom-target={"Timecards-Reports-Select-ReportType"}
                    floatingLabelText={strings.Estimated_Time_Report_Type}
                    floatingLabelStyle={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}
                    value={this.state.reportType}
                    onChange={(e, key, payload) => this.setState({ reportType: payload })}
                >
                    <MenuItem value={EEstimatedTimeReportType.Weekly} primaryText={strings.Weekly} />
                    <MenuItem value={EEstimatedTimeReportType.Daily} primaryText={strings.Daily} />
                </SelectField>
                <div style={{ color: grey800 }}>
                    {this.state.reportType === EEstimatedTimeReportType.Weekly ?
                        <TimecardDateRange
                            referenceDate={this.state.referenceDate}
                            payCalendar={this.props.selectedPayrollPayCalendar}
                            handleChangeReferenceDate={referenceDate => this.setState({ referenceDate })}
                        /> :
                        <div style={{ marginTop: 15 }}>
                            {moment(this.state.referenceDate).utc().format("ddd MMM. DD, YYYY")}
                            <IconButton data-intercom-target={"Timecards-Reports-Btn-OpenDatePicker"} onTouchTap={() => this.FinddDatePicker.DatePicker.openDialog()} tooltip={"Pick a date"}>
                                <FontIcon className={"fa fa-calendar fa-lg"} />
                            </IconButton>
                            <FinddDatePicker
                                ref={elem => (this.FinddDatePicker = elem)}
                                id={"dp-text-field"}
                                textFieldStyle={{ display: "none" }}
                                value={moment(this.state.referenceDate).toDate()}
                                onChange={(_, date) => this.setState({ referenceDate: moment(date).add(this.props.selectedPayrollPayCalendar.PayPeriodDayStartTime24Hour, "hour") })}
                                maxDate={new Date()}
                                cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
                                firstDayOfWeek={0}
                            />
                        </div>
                    }
                </div>
            </Dialog>
        )
    }
}